import React from 'react'
import { useSelector } from 'react-redux'

import BaseEntity from 'app/components/BaseEntity'
import constants from 'app/constants'
import {
  fetchPlannerLayoutData,
  updatePlannerData
} from 'app/store/actions/lessonPlannerEntity'

import { columns } from './config'

/** Spatial layouts admin (Circle on floor, Small groups at tables, ...). */
const Layouts = () => {
  const data = useSelector(
    (state) => state.lessonPlannerEntityReducer.plannerLayoutData
  )

  return (
    <BaseEntity
      entity={constants.PLANNER_LAYOUT}
      label={constants.PLANNER_LAYOUT_LABEL}
      columns={columns}
      data={data}
      fetchData={fetchPlannerLayoutData}
      updateEntityData={updatePlannerData}
    />
  )
}

export default Layouts
